import {defineStore} from 'pinia';
import Storage from '@services/storage';
import AuthApi from '@api/auth.api';
import UserApi from '@api/user.api';
import ability from '@services/ability';
import {forEach} from "lodash";

const USER_COOKIE_KEY = '__Secure-Entity';

export const useUserStore = defineStore('user', {
    state() {
        return {
            user: {},
            id: "",
            name: "",
            roles: [],
            permissions: [],
        };
    },
    getters: {
        getUserData(state) {
            return state.user;
        },
    },
    actions: {
        async login(userInfo) {
            const {email, password} = userInfo;
            await AuthApi.csrf();
            return await AuthApi.login({
                email: email.trim(),
                password: password,
            }).then((response) => {
                this.setUserData(response.data.data);
                return response;
            });
        },
        async resetPassword({}, resetData) {
            const {email} = resetData;
            return await AuthApi.resetPassword({
                email: email.trim(),
            }).then((response) => {
                // console.log('reset password done...');
                return response;
            });
        },
        setUserData(data) {
            this.user = data;
            this.id = data.id;
            this.name = data.name;
            this.permissions = data.permissions;
            this.roles = data.roles_ids;
            Storage.set(USER_COOKIE_KEY, data);
        },
        // user logout
        logout() {
            return new Promise((resolve, reject) => {
                try {
                    AuthApi.logout()
                        .then((response) => {
                            this.resetUser();
                            resolve(response);
                        })
                        .catch((error) => {
                            reject(error);
                        });
                } catch (error) {
                    reject(error);
                }
            });
        },

        // remove token
        resetUser() {
            this.user = {};
            this.permissions = [];
        },

        hasPermission(action, module) {
            let check = false;

            if (this.user && this.user.roles && this.user.roles.includes('Super Admin')) {
                return true;
            }

            if (this.permissions.length <= 0) {
                return check;
            }
            const modulePermissions = this.permissions.filter(
                (permission) => permission.model === module
            );

            forEach(modulePermissions, function (ob) {
                if (ob.action === action) {
                    check = true;
                    return true;
                }
            });
            return check;
        },

        hasRole(role) {
            return this.user.roles && this.user.roles.includes(role);
        },

        async checkSocialLogin(token) {
            return await AuthApi.checkSocialLogin(token).then((response) => {
                this.setUserData(response.data.data.user);
                return response;
            });
        },
    },
    persist: true,
});
